module.exports = __webpack_public_path__ + "static/make-video-slide5-a19d76c27bf385d12c37e70dbefa7486.png";